import { Button, Stack } from '@figma/fpl-components';
import { Icon24ChevronLeftLarge } from '@figma/fpl-icons';
import { color, spacer } from '@figma/fpl-tokens/tokens.stylex';
import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TOOLKIT_PATH } from '@/components/Dashboard/enums/shared';
import { WorkflowCreditsDisplay } from '@/components/Recipe/FlowComponents/WorkflowRightToolbar/WorkflowCreditsDisplay';
import { I18N_KEYS } from '@/language/keys';
import { Tooltip } from '@/UI/Tooltip/Tooltip';

/**
 * Top bar of the generate page: Back on the left and, for signed-in users, the credits balance. Back always
 * opens the Toolkit, wherever the person came from.
 */
export function GenerateHeader({ signedIn }: { signedIn: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack.Row {...stylex.props(styles.root)} justify="space-between" gap={4}>
      <Tooltip title={t(I18N_KEYS.GENERATE_PAGE.BACK_TO, { page: t(I18N_KEYS.NAVIGATION_DRAWER.TOOLKIT) })}>
        <Button variant="ghost" iconPrefix={<Icon24ChevronLeftLarge />} onClick={() => navigate(TOOLKIT_PATH)}>
          {t(I18N_KEYS.GENERATE_PAGE.BACK)}
        </Button>
      </Tooltip>
      {signedIn && <WorkflowCreditsDisplay showCreditsLabel />}
    </Stack.Row>
  );
}

const styles = stylex.create({
  root: {
    flexShrink: 0,
    boxSizing: 'border-box',
    paddingBlock: spacer.spacer8px,
    // Less on the left, as in the design: the button's own padding already sets its label in.
    paddingLeft: spacer.spacer8px,
    paddingRight: spacer.spacer12px,
    backgroundColor: color.bg,
    color: color.text,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.border,
  },
});
